import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="prevent-back"
export default class extends Controller {
  connect() {
    window.addEventListener('pageshow', this.handlePageShow)
  }

  disconnect() {
    window.removeEventListener('pageshow', this.handlePageShow)
  }

  handlePageShow(event) {
    if (event.persisted) window.location.reload();
  }
}
